"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.od = exports.assureOrderDescending = exports.o = exports.assureOrder = exports.assureOrderRecipe = void 0;
const types_internal_1 = require("../types-internal");
function assureOrderRecipe(direction) {
    return function () {
        this[types_internal_1.orderAssured] = direction;
        return this;
    };
}
exports.assureOrderRecipe = assureOrderRecipe;
exports.assureOrder = assureOrderRecipe(1);
exports.o = exports.assureOrder;
exports.assureOrderDescending = assureOrderRecipe(-1);
exports.od = exports.assureOrderDescending;
